import { CheckboxOptionType, Radio } from 'antd';
import { RadioGroupProps } from 'antd/lib/radio';
import { forwardRef } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

interface IInputWrapProps extends RadioGroupProps {
  field?: ControllerRenderProps<any, any>;
  options?: (string | number | CheckboxOptionType<any>)[];
}

export const RadioGroup = forwardRef<HTMLDivElement, IInputWrapProps>(
  ({ className, options = [], field, ...props }, ref) => {
    return (
      <Radio.Group
        ref={ref}
        className={className}
        {...props}
        options={options}
      />
    );
  },
);
